import axios from "axios";

/**
 * Make an API call with given params
 * @param {'get' | 'post' | 'put' | 'delete' | 'patch'} method - HTTP method
 * @param {string} path - API endpoint
 * @param {FormData | object} formData - data to send
 * @param {string} token - the auth token
 * @param onSuccess - callback for success case, using received response
 * @param onError - callback for error case, using received error
 */
export function apiCall({method, path, data = null, token = null, onSuccess, onError, companyId, auth = null}) {
    const headers = {
        'X-CSRF-TOKEN': document.querySelector('[name="csrf-token"]')?.getAttribute("content"),
    };

    if (token || auth?.token) {
        headers['AccessToken'] = token ? token : auth?.token;
    }

    axios({
        method,
        url: path,
        data,
        headers
    })
        .then(response => onSuccess(response))
        .catch(error => onError ? onError(error) : null);
}
